import { baseAxios } from "config";

/**
 * Deletes a dynamic form by its ID
 * @param {string} formId - The ID of the form to delete
 * @returns {Promise} - The API response
 */
const deleteDynamicForm = async (formId) => {
  try {
    const response = await baseAxios.delete(`/llm/dynamicForms/${formId}`);
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export default deleteDynamicForm;
